import { LazyQueryExecFunction } from "@apollo/client";
import {
  Exact,
  GetAssetCarryingValueQuery,
  GetLastPresentValueByAssetIdQuery,
  useGetAssetCarryingValueLazyQuery,
  useGetLastPresentValueByAssetIdLazyQuery,
} from "graphql/queries/generated/queries";
import useStagger from "helpers/useStagger";

const useGetAssetCurrentValue = () => {
  // related to https://github.com/apollographql/apollo-client/issues/9755
  const [BROKEN_getAssetCarryingValue] = useGetAssetCarryingValueLazyQuery();
  const getAssetCarryingValue: LazyQueryExecFunction<
    GetAssetCarryingValueQuery,
    Exact<{
      id: string;
    }>
  > = useStagger(BROKEN_getAssetCarryingValue);

  // related to https://github.com/apollographql/apollo-client/issues/9755
  const [BROKEN_getLastPresentValueByAssetId] = useGetLastPresentValueByAssetIdLazyQuery();
  const getLastPresentValueByAssetId: LazyQueryExecFunction<
    GetLastPresentValueByAssetIdQuery,
    Exact<{
      id: string;
    }>
  > = useStagger(BROKEN_getLastPresentValueByAssetId);

  const doUseGetAssetCurrentValue = async (
    id: string
  ): Promise<null | { currency: string; amount: number }> => {
    try {
      const { data: getLastPresentValueByAssetIdData } = await getLastPresentValueByAssetId({
        variables: {
          id,
        },
      });

      if (!getLastPresentValueByAssetIdData?.asset?.presentValues) {
        const { data: getAssetCarryingValueData } = await getAssetCarryingValue({
          variables: {
            id,
          },
        });

        if (!getAssetCarryingValueData) return null;

        if (!getAssetCarryingValueData.asset?.carryingValueAmount) return null;

        return {
          amount: getAssetCarryingValueData.asset.carryingValueAmount.amount,
          currency: getAssetCarryingValueData.asset.carryingValueAmountCurrency,
        };
      }

      const {
        asset: {
          presentValues: { edges },
        },
      } = getLastPresentValueByAssetIdData;
      if (edges.length === 0) return null;

      const { node } = edges[0];
      const { amountCurrency, amount } = node;
      return { amount: amount?.amount, currency: amountCurrency };
    } catch {
      return null;
    }
  };

  return doUseGetAssetCurrentValue;
};

export default useGetAssetCurrentValue;
